export default {
  init() {
    // JavaScript to be fired on the free estimate page
    const google = window.google;

    (function initialize_gmap() {
      var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

      var isDraggable = w > 480 ? true : false;

      var map = new google.maps.Map(document.getElementById('serviceMap'), {
        zoom: 6,
        scrollwheel: false,
        draggable: isDraggable,
        center: {lat: 45.5000, lng: -69.0000},
        disableDefaultUI: true,
        mapTypeId: google.maps.MapTypeId.ROAD,
      });

      var maineMapPolygon =  [
        {lat: 45.3425, lng: -71.0129},
        {lat: 45.3328, lng: -70.9525},
        {lat: 45.2294, lng: -70.8618},
        {lat: 45.3917, lng: -70.8247},
      {lat: 45.4274, lng: -70.7808},
 {lat: 45.3830, lng: -70.6380},
        {lat: 45.5092, lng: -70.7190},
        {lat: 45.6544, lng: -70.5721},
 {lat: 45.7292, lng: -70.3894},
       {lat: 45.7924, lng: -70.4169},
         {lat: 45.67664, lng: -67.833},
        {lat: 45.5987, lng: -67.4533},
        {lat: 45.5044, lng: -67.4176},
        {lat: 45.4823, lng: -67.5014},
        {lat: 45.3714, lng: -67.4231},
        {lat: 45.2768, lng: -67.4863},
        {lat: 45.1297, lng: -67.3434},
        {lat: 45.1830, lng: -67.2487},
        {lat: 45.1230, lng: -67.1223},
        {lat: 44.8315, lng: -66.9672},
        {lat: 44.7409, lng: -66.8628},
        {lat: 44.4945, lng: -67.3105},
        {lat: 44.3268, lng: -67.9051},
        {lat: 43.8702, lng: -68.6673},
        {lat: 43.7274, lng: -68.8431},
            ];
      var maineMap = new google.maps.Polygon({
        path: maineMapPolygon,
        strokeColor: '#FF0000',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
      });

      maineMap.setMap(map);

      google.maps.event.addDomListener(window, 'resize', function() {
        var center = map.getCenter();
        google.maps.event.trigger(map, 'resize');
        map.setCenter(center);
      });
    }());
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/free-estimate.js